import { useState } from 'react';

const KEY = 'motrusse_uid';

const useUser = () => {
  const [userId] = useState(() => {
    try {
      let id = localStorage.getItem(KEY);
      if (!id) {
        id = crypto.randomUUID();
        localStorage.setItem(KEY, id);
      }
      return id;
    } catch {
      return null; // localStorage unavailable (private browsing, etc.)
    }
  });

  const resetUser = () => {
    try {
      const id = crypto.randomUUID();
      localStorage.setItem(KEY, id);
      window.location.reload();
    } catch {}
  };

  return { userId, resetUser };
};

export default useUser;
